import React from 'react';
import moment from 'moment';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export default function DateField({ id, name, variant, minDays, onChange, value, operator, ...others }) {
    const handleChange = (event) => {
        onChange && onChange(event)
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                // clearable
                variant={variant}
                format="MM/dd/yyyy"
                disableFuture
                initialFocusedDate={new Date()}
                onChange={value => handleChange({
                    target: { id: id || name, value }
                })}
                minDate={minDays ? moment().subtract(minDays, "days") : new Date("01/01/1900")}
                value={value || null}
                name={name}
                {...others}
            />
        </MuiPickersUtilsProvider>
    )
}